<template>
    <div id="PageNotFound">
        <div class="container-fluid bg-white">
            <div class="text-center" style="margin-top:10%;">
                <div class="error-template">
                    <h1>
                        Oops!</h1>
                    <h2>
                        404 Page Not Found</h2>
                    <div class="error-details">
                        Sorry, an error has occured, requested page not found!
                    </div>
                    
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>            
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
export default {
    name:"PageNotFound",
    
    mixins:[commonMixins],
    mounted: function() {

        var self = this;
        self.getPermissions();
    }
}
</script>




// WEBPACK FOOTER //
// src/components/PageNotFound.vue